import React from 'react';
import styled from 'styled-components';

import { IconWrapper } from '@rover/components/src/formFields/IconSelect/IconOption';
import { FilterLabel } from '@rover/components/src/formFields/ServiceTypeFilter/ServiceTypeFilter';
import DogTraining from '@rover/icons/svg/dog-training.svg';
import { Flex, Text } from '@rover/kibble/core';

const ButtonWrapper = styled(Flex)`
  // The above component styles but translated to CSS
  align-items: center;
  border-radius: 4px;
  padding: 8px 18px;
  border: ${({ theme }) =>
    `${theme.borderWidth.primary} solid ${theme.colors.interactive_border.disabled}`};
  position: relative;
  background-color: ${({ theme }) => theme.background.interactive.disabled};
`;

interface StaticServiceTypeFilterProps {
  showLabel?: boolean;
}
/**
 * A faux service type filter component, as the one on the training serach page
 * is not intended to be interactive or have other options.
 */
export default function StaticServiceTypeFilter({
  showLabel,
}: StaticServiceTypeFilterProps): JSX.Element {
  return (
    <>
      {showLabel && <FilterLabel>Service type</FilterLabel>}
      <ButtonWrapper>
        <IconWrapper>
          <DogTraining />
        </IconWrapper>
        <Flex flexDirection="column">
          {/* TODO (DEV-104195): Translate */}
          <Text size="200" fontWeight="semibold" textColor="secondary">
            Dog Training
          </Text>
          {/* TODO (DEV-104195): Translate */}
          <Text size="100" textColor="secondary">
            with a private trainer
          </Text>
        </Flex>
      </ButtonWrapper>
    </>
  );
}
